import { __extends } from "tslib";
import moment from "moment";
import React from "react";
import DatePicker from "react-datepicker";
import { dateTime } from "../../constants/dateTime";
import "../../../style/components/customDatePicker.scss";
import { DatePickerIcon } from "./DatePickerIcon";
var CustomDatePicker = (function (_super) {
    __extends(CustomDatePicker, _super);
    function CustomDatePicker(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChange = function (e) {
            _this.props.onDateInputChangedCallback(e);
        };
        _this.handleBlur = function (e) {
            var startDate = _this.props.startDate;
            var minDate = _this.props.minDate;
            var maxDate = _this.props.maxDate;
            console.log(startDate);
            if (moment(startDate, dateTime.dateFormat).isValid() &&
                /(\d{4})-(\d{2})-(\d{2})/.test(startDate) &&
                ((minDate &&
                    moment(minDate, dateTime.dateFormat) <=
                        moment(startDate, dateTime.dateFormat)) ||
                    (maxDate &&
                        moment(maxDate, dateTime.dateFormat) >=
                            moment(startDate, dateTime.dateFormat)))) {
                _this.props.onDateInputChangedCallback(e);
                _this.setState({
                    previousDate: startDate,
                });
            }
            else {
                _this.props.onDateSelectedCallback(_this.props.name, startDate);
            }
        };
        _this.handleSelect = function (date) {
            _this.setState({
                previousDate: date.format(dateTime.dateFormat),
            });
            _this.props.onDateSelectedCallback(_this.props.name, date.format(dateTime.dateFormat));
        };
        var startDate = _this.props.startDate;
        _this.state = {
            previousDate: startDate,
        };
        return _this;
    }
    CustomDatePicker.prototype.render = function () {
        var _a = this.props, name = _a.name, startDate = _a.startDate, minDate = _a.minDate, maxDate = _a.maxDate;
        var selectedDate = moment(startDate, dateTime.dateFormat);
        var minSelectedDate = moment(minDate, dateTime.dateFormat);
        var maxSelectedDate = moment(maxDate, dateTime.dateFormat);
        return (React.createElement("div", { className: "rb-datepicker" },
            React.createElement("input", { className: "rb-input", name: name, type: "text", value: startDate, placeholder: dateTime.dateFormat, onChange: this.handleChange, onBlur: this.handleBlur }),
            React.createElement(DatePicker, { customInput: React.createElement(DatePickerIcon, null), selected: selectedDate.isValid() ? selectedDate : null, minDate: minSelectedDate.isValid() ? minSelectedDate : null, maxDate: maxSelectedDate.isValid() ? maxSelectedDate : null, onChange: this.handleSelect })));
    };
    return CustomDatePicker;
}(React.Component));
export { CustomDatePicker };
